import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import BusinessDashboardBlockData from '../../../Models/Content/BusinessDashboardBlockData';
import BusinessDashboardMain from './BusinessDashboardMain';


export default class BusinessClientEsimUpgradeBlock extends EpiComponent<BusinessDashboardBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <BusinessDashboardMain context={this.getContext()} contentData={this.props.data} />;
  }
}
